// extracted by mini-css-extract-plugin
export default {"logo_container":"style_logo_container__-T+Iq","logo":"style_logo__AEiW1"};